import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const recieverApi = createApi({
    reducerPath: 'recieverApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://onza-api.ibm.kg/api/common/',
        prepareHeaders: (headers, { getState }) => {
            let { auth: { auth } } = getState();
            if (typeof auth == "string") {
                auth = JSON.parse(auth);
            }
            headers.set("Authorization", `Bearer ${auth?.accessToken}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getReciever: builder.query({
            query: () => `recieverList`,
        }),
        getRecieverByCode: builder.query({
            query: (client_code) => {
                return {
                    url: `reciever`,
                    params: {
                        client_code: client_code
                    }
                }
            },
        }),
        getAllRecieverByCode: builder.query({
            query: (client_code) => {
                return {
                    url: `all-reciever`,
                    params: {
                        client_code: client_code
                    }
                }
            },
        })
    }),
})

export const { useGetRecieverQuery, useGetRecieverByCodeQuery, useGetAllRecieverByCodeQuery } = recieverApi